import { useState } from "react";
import { Outlet, useParams } from "react-router";
import { TabNav } from "@/components/TabNav";
import { plural } from "@/lib/plural";

const tabs = [
  { label: "Audit log", to: "audit" },
  { label: "SSH recordings", to: "ssh-recordings" },
  { label: "RDP recordings", to: "rdp-recordings" },
  { label: "Database recordings", to: "database-recordings" },
  { label: "Kubernetes recordings", to: "kubernetes-recordings" },
  { label: "AI recordings", to: "ai-recordings" },
];

export interface LogsSummary {
  total: number;
  noun: string;
}

export interface LogsLayoutContext {
  setSummary: (summary: LogsSummary | null) => void;
}

export function LogsLayout() {
  const { orgId } = useParams();
  const [summary, setSummary] = useState<LogsSummary | null>(null);

  return (
    <div className="text-foreground">
      <div className="mb-4">
        <h1 className="text-2xl font-semibold tracking-tight">Logs</h1>
        {summary && (
          <p className="mt-0.5 text-sm text-foreground/70">
            {plural(summary.total, summary.noun)}
          </p>
        )}
      </div>

      <TabNav tabs={tabs} basePath={`/${orgId}/logs`} />

      <Outlet context={{ setSummary } satisfies LogsLayoutContext} />
    </div>
  );
}
